import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userMid: null, // 用户mid
    userName: null,// 用户姓名
    userMthumb: null, //  用户头像
    upTree:false,      //  是否更新树状图
    userRoleid: null,  //  用户权限
    allToken:null

  },
  mutations: {},
  actions: {}
})
